import React from 'react';
export function FAQToSuperfoodsDivider() {
  return <div className="relative w-full overflow-hidden" style={{
    backgroundColor: '#f5f1ed'
  }} data-id="element-98">
      

      <style data-id="element-99">{`
        @keyframes faqToSuperfoodsWave {
          0%, 100% {
            transform: translateX(0) scaleY(1);
          }
          50% {
            transform: translateX(-25px) scaleY(1.05);
          }
        }
        
        @media (prefers-reduced-motion: reduce) {
          svg path {
            animation: none !important;
          }
        }
      `}</style>
    </div>;
}